import React, {
  useEffect,
  useState,
} from 'react';

import {
  Box,
  Button,
  Flex,
  Image,
  Input,
} from '@chakra-ui/react';

import {
  PageWrapper,
  SectionTitle,
  Spacer,
  Text,
} from '../../components';
import {
  cockpitGet,
  getCockpitAssetUrl,
} from '../../config/cockpit';
import { useHeader } from '../../contexts/useHeader';
import { TextType } from '../../models/Text';

interface CockpitAsset {
  path?: string;
}

interface GlobalData {
  logoBlack?: CockpitAsset;
  'logoBlack-square'?: CockpitAsset;
}

const LoginPage = () => {
  const { headerDimensions } = useHeader();

  const [logoUrl, setLogoUrl] =
    useState('');

  useEffect(() => {
    cockpitGet<GlobalData>(
      '/api/content/item/Global'
    )
      .then((data) => {
        const asset =
          data['logoBlack-square'] ||
          data.logoBlack;

        if (asset?.path) {
          setLogoUrl(
            getCockpitAssetUrl(
              asset.path
            )
          );
        }
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.error(
          'Failed to load login logo from Cockpit:',
          err
        );

        setLogoUrl('');
      });
  }, []);

  const handleLogin = (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();

    // Authentication is not enabled yet.
    // LDAP / SSO will be added later.
  };

  return (
    <PageWrapper>
      <Spacer
        size={
          headerDimensions?.height || 0
        }
      />

      <Flex
        width="100%"
        minHeight="70vh"
        justifyContent="center"
        alignItems="flex-start"
        paddingTop={{
          base: '40px',
          md: '80px',
        }}
        paddingBottom={{
          base: '60px',
          md: '100px',
        }}
        paddingX="20px"
      >
        <Box
          width="100%"
          maxWidth="500px"
        >
          {logoUrl ? (
            <Flex
              width="100%"
              justifyContent="center"
              marginBottom={{
                base: '30px',
                md: '45px',
              }}
            >
              <Image
                src={logoUrl}
                alt="arch4D"
                width={{
                  base: '120px',
                  md: '150px',
                }}
                height="auto"
                objectFit="contain"
              />
            </Flex>
          ) : null}

          <SectionTitle
            title="Portal Login"
            description="Portal access is currently unavailable."
            noPadding
          />

          <Box
            as="form"
            marginTop="40px"
            onSubmit={handleLogin}
          >
            <Text
              type={
                TextType.Inter12Regular
              }
              color="gray.600"
            >
              USERNAME
            </Text>

            <Input
              name="username"
              type="text"
              autoComplete="username"
              marginTop="10px"
              borderRadius={0}
              borderColor="gray.200"
              size="lg"
              isDisabled
            />

            <Box marginTop="25px">
              <Text
                type={
                  TextType.Inter12Regular
                }
                color="gray.600"
              >
                PASSWORD
              </Text>
            </Box>

            <Input
              name="password"
              type="password"
              autoComplete="current-password"
              marginTop="10px"
              borderRadius={0}
              borderColor="gray.200"
              size="lg"
              isDisabled
            />

            <Button
              type="submit"
              width="100%"
              marginTop="35px"
              borderRadius={0}
              bgColor="primary"
              isDisabled
            >
              <Text
                type={
                  TextType.Inter12Bold
                }
                color="white"
              >
                LOGIN
              </Text>
            </Button>
          </Box>
        </Box>
      </Flex>
    </PageWrapper>
  );
};

export default LoginPage;